import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

const feedbackById = '/feedback_request/:id';
const feedbackComments = '/feedback_comments/';

export async function getFeedbackRequest(id) {
  const response = await api.get(
    generatePath(feedbackById, { id }),
    config('json')
  );
  return response.data;
}

export async function getFeedbackCommentsRequest(id) {
  const response = await api.get(
    feedbackComments,
    config('json', { feedback_request_id: id })
  );
  return response.data;
}

export async function rejectFeedbackRequest({ id, comment }) {
  return await api.patch(
    generatePath(feedbackById, { id }),
    {
      status: 'reject',
      comment: comment
    },
    config('json')
  );
}

export async function sendFeedbackCommentRequest({ id, comment }) {
  return await api.post(
    feedbackComments,
    {
      feedback_request_id: id,
      comment: comment
    },
    config('json')
  );
}

export async function uploadFeedbackCommentAttachment(feedbackCommentId, file) {
  const formData = new FormData();
  formData.append('file', file);

  return await api.post(
    `/feedback_comments/${feedbackCommentId}/media`,
    formData,
    config('form')
  );
}
